import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Icon } from '@iconify/react';

// import Box from '@mui/material/Box';


const Iconify = forwardRef( ( { icon, width = 20, sx, ...other }, ref ) => (
  <div
    ref={ ref }
    className="component-iconify"
    style={ { width, height: width, ...sx } }
    { ...other }
  >
    <Icon icon={ icon } />
  </div>
) );

Iconify.propTypes = {
  icon: PropTypes.oneOfType( [ PropTypes.element, PropTypes.string ] ),
  sx: PropTypes.object,
  width: PropTypes.number,
};

export default Iconify;